<template>
  <nav :id="id"
    class="
      breadcrumb
      has-succeeds-separator
      is-marginless
      has-background-white"
    aria-label="breadcrumbs">

    <ul>
      <li
        :class="{'is-active': !!!breadcrumb.to.name}"
        v-for="breadcrumb in breadcrumbs"
        v-bind:key="breadcrumb.text">
        <router-link v-if="breadcrumb.to" :to="{
            name: breadcrumb.to.name,
            path: breadcrumb.to.path,
          }">
          {{ breadcrumb.text }}
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';

export default {
  mixins: [BreadcrumbsManager],
  props: ['id'],
};
</script>

<style lang="sass" scoped>
  .breadcrumb
    box-shadow: 0 0 3px #aaa
    padding-left: 1rem
  a
    &:hover
      text-decoration: none
</style>
